import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=3dec87fe&scoped=true&"
import script from "./EventPreview.vue?vue&type=script&lang=js&"
export * from "./EventPreview.vue?vue&type=script&lang=js&"
import style0 from "./EventPreview.vue?vue&type=style&index=0&id=3dec87fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec87fe",
  null
  
)

export default component.exports